import { getCollectionsFieldMap } from '@wix/wix-data-client-common'
import type { PresetDefinition, AppApi } from '@wix/wix-data-client-common'
import type { Schema } from '@wix/wix-data-schema-types'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'

export const getFieldMap = async ({
  preset,
  appApi,
  newCollectionSchema,
  controllerRef,
  pageLinkFieldKey,
}: {
  preset: PresetDefinition
  appApi: AppApi
  newCollectionSchema: Schema
  controllerRef: ComponentRef
  pageLinkFieldKey?: string
}) => {
  const presetCollection = preset.collections[0]
  const fieldMap = await getCollectionsFieldMap({
    appApi,
    controllerRef,
    sourceSchema: presetCollection.schema,
    destinationSchema: newCollectionSchema,
    pageLinkFieldKey,
  })

  return { fieldMap }
}
